import { createLogic } from 'redux-logic'
// import { map, exhaustMap } from 'rxjs/operators'
import { map, take } from 'rxjs/operators'
import * as constants from '../constants'
import { normalize } from '@engine/dependencies'

export const compsImageUrls = createLogic({
  type: constants.SET_COMPS.ACTION,
  processOptions: {
    successType: constants.SET_COMPS.FULFILLED,
    failType: constants.SET_COMPS.REJECTED
  },
  process({ http, action }) {
    const propertyIdList = action.payload.propertyInfo.Summary && action.payload.propertyInfo.Summary.reduce((prev, cur) => prev.concat(cur.propertySFId), [])

    return http
      .post('/comps/photos/query', { propertyIdList })
      .pipe(
        take(1),
        map(http.getBody),
        map(res => (
          {
            compsData: normalize.updatePropertyData(action.payload.propertyInfo, res),
            projectName: action.payload.fileName,
            barChartData: action.payload.barChartData,
            fpSummaryData: action.payload.fpSummaryData,
            fpBarChartData: action.payload.fpBarChartData,
            templateName: action.payload.templateName
          }
        ))
      )
  }
})
